import api from '../../api';
// 获取简介
export function getCompany(params) {
  return api.post('/company/getCompany.go', params, false, false).then(res => res);
}
// 修改简介
export function upCompany(params) {
  return api.post('/company/upCompany.go', params, false, false).then(res => res);
}



// WEBPACK FOOTER //
// ./src/api/adminApi/zh/briefIntroduction.js